import {AssetDecoder} from '../../../vendor/react-native-tapnovel-viewer';

export default AssetDecoder;
